module.exports = __webpack_public_path__ + "img/sm-2017-11-16_13-03-53.49cd6ddc.jpg";